@if (trainingDetails()) {
  <div class="www-pro-edu-tra-top" [appAnimate]="'landing'" [speed]="'fast'">
    <div class="www-pro-edu-tra-top__desc">
      <h1 class="www-pro-edu-tra-top__desc__tit" [appAnimate]="'landing'" [speed]="'fast'">
        {{ trainingDetails()!.name }}
      </h1>

      @if (trainingDetails()!.price === 0 && trainingDetails()!.slug !== 'sniadanie-networkingowe') {
        <p class="www-pro-edu-tra-top__desc__ava" [appAnimate]="'landing'" [speed]="'fast'">Szkolenie bezpłatne</p>
      } @else if (trainingDetails()!.price === 0 && trainingDetails()!.slug !== 'sniadanie-networkingowe') {
        <p class="www-pro-edu-tra-top__desc__pri" [appAnimate]="'landing'" [speed]="'fast'">Szkolenie na zaproszenie</p>
      } @else {
        <p class="www-pro-edu-tra-top__desc__pri" [appAnimate]="'landing'" [speed]="'fast'">
          <!-- {{ trainingDetails()!.price ? trainingDetails()!.price + ' PLN' : 'SZKOLENIE BEZPŁATNE' }} -->

          @if (user()) {
            <span>
              <s>{{ trainingDetails()!.price + ' PLN' }}</s
              >&nbsp;{{
                user()?.type === UserType.MEMBER
                  ? (trainingDetails()!.price * 0.9 | mask: 'separator.2') + ' PLN'
                  : (trainingDetails()!.price * 0.8 | mask: 'separator.2') + ' PLN'
              }}
            </span>
            @if (user()) {
              <small class="d-block my-1" style="color: #898989; font-size: 13px">Twoja cena PRO.CONNECT</small>
            }
          } @else {
            <span>{{ trainingDetails()!.price > 0 ? trainingDetails()!.price + ' PLN' : 'Szkolenie bezpłatne' }}</span>
          }
        </p>
      }

      @if (trainingDetails()!.short_description) {
        <p
          class="www-pro-edu-tra-top__desc__des"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.5"
          [delay]="'300'"
          [innerHtml]="trainingDetails()!.short_description"
        ></p>
      }

      @if (trainingDetails()!.description) {
        <p
          class="www-pro-edu-tra-top__desc__des"
          [appAnimate]="'landing'"
          [speed]="'fast'"
          [aos]="0.5"
          [delay]="'300'"
          [innerHtml]="trainingDetails()!.description"
        ></p>
      }

      @if (trainingDetails()!.events.length) {
        <p class="www-pro-edu-tra-top__desc__ava" [appAnimate]="'landing'" [speed]="'fast'">DOSTĘPNE TERMINY</p>

        <div
          class="www-pro-edu-tra-top__desc__mee"
          [ngClass]="{ 'www-pro-edu-tra-top__desc__mee--cha-pad': trainingDetails()!.events.length > 9 }"
        >
          @for (e of trainingDetails()!.events; track $index) {
            <div
              class="www-pro-edu-tra-top__desc__mee__item"
              [ngClass]="{ soldout: e.free_seats < 1 }"
              (click)="goToEvent(e)"
            >
              {{ e.start_date | date: 'dd.MM.yyyy' }}
              {{
                e.free_seats < 1 ? ' - SOLDOUT' : e?.place ? ' - ' + (e.place ? (e.place.city | uppercase) : '') : ''
              }}
            </div>
          }
        </div>
      } @else {
        <p class="www-pro-edu-tra-top__desc__ava" [appAnimate]="'landing'" [speed]="'fast'">BRAK DOSTĘPNYCH TERMINÓW</p>
      }
    </div>

    <img
      class="www-pro-edu-tra-top__img"
      [appAnimate]="'fadeInRight'"
      [speed]="'fast'"
      [aos]="0.5"
      [delay]="'300'"
      [src]="trainingDetails()!.main_photo"
      [alt]="trainingDetails()!.main_photo"
    />

    <img
      class="www-pro-edu-tra-top__dots"
      ngSrc="assets/images/pages/account/pro-education/dots.webp"
      width="464"
      height="334"
      alt="dots"
    />
  </div>
}
